<template>
  <div>
    <transition name="fade">
      <component
        :is="layout"
        v-if="fetched">
        <transition name="switch">
          <router-view :key="$route.fullPath" />
        </transition>
      </component>
    </transition>
    <products-search-popup
      v-if="productsSearchPopupIsOpen"
      :currency-id="-1"
      :products-discount="0"
      :selected-currency-symbol="'PLN'"
      :product-index="0"
      :selected-tag-category="null"
      :selected-tag-category-value="null"
      :tag-categories="tagCategories"
      :hide-buttons="true" />
  </div>
</template>

<script>
import FormUtils from './utils/FormUtils.js';
import SanitizeUtils from './utils/SanitizeUtils.js';
import ProductsSearchPopup from './components/orders/ProductsSearchPopup.vue';

export default {
  name: 'App',
  components: {
    'products-search-popup': ProductsSearchPopup
  },
  data () {
    return {
      fetched: false,
      user: {},
      loadUserError: false,
      loadedTagCategories: false,
      tagCategories: [],
      productsSearchPopupIsOpen: false
    }
  },
  computed: {
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
  mounted () {
    let self = this;

    window.crmApp = {
      permissionsAvailable () {
        return self.$store.state && self.$store.state.user && self.$store.state.user.permissions;
      },
      hasPermissions (permissionName) {
        return self.$store.state.user.permissions && self.$store.state.user.permissions[permissionName];
      }
    };

    this.$bus.$on('sidebar-products-search-popup-show', this.openProductsSearchPopup);
    this.$bus.$on('products-search-popup-close', this.closeProductsSearchPopup);

    if (!SanitizeUtils.getToken()) {
      this.fetched = true;
      return;
    }

    FormUtils.loadAdditionalData(this, {
      endpoint: '/users/item/me',
      outputKey: 'user',
      errorKey: 'loadUserError',
      successAction: (response) => {
        this.fetched = true;

        if (response && response.type === 'customer') {
          this.submitting = false;
          this.$router.push('/logowanie/invalid');
          return;
        }

        this.$store.commit('setCustomerID', response.customer_id);
        this.$store.commit('setUserID', response.id);
        this.$store.commit('setUserName', response.name);
        this.$store.commit('setUserEmail', response.email);
        this.$store.commit('setUserPermissions', response.permissions);
        this.$store.commit('setUserType', response.type);
        this.$store.commit('setUserLang', response.language_id);

        let currentLanguageID = this.$i18n.locale === 'pl' ? 1 : 2;

        if (response.language_id > 0 && currentLanguageID !== response.language_id) {
          window.localStorage.setItem('headwear-crm-ui-language', response.language_id);
          window.location.reload();
        }

        FormUtils.loadAdditionalData(this, {
          endpoint: '/tags/categories/items',
          loadedKey: 'loadedTagCategories',
          outputKey: 'tagCategories',
          errorKey: 'loadError',
          params: {
            with: ['tags']
          }
        });
      }
    });
  },
  methods: {
    openProductsSearchPopup () {
      this.productsSearchPopupIsOpen = true;
    },
    closeProductsSearchPopup () {
      this.productsSearchPopupIsOpen = false;
    }
  },
  beforeDestroy() {
    this.$bus.$off('sidebar-products-search-popup-show', this.openProductsSearchPopup);
    this.$bus.$off('products-search-popup-close', this.closeProductsSearchPopup);
  }
};
</script>

<style lang="scss">
@import './assets/scss/custom-elements.scss';

.switch-enter-to,
.switch-leave-to {
  transition: opacity .25s ease-out;
}

.switch-enter,
.switch-leave-to {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: none;
  width: 100%;
}
</style>
